import {
  getAdvisorFullNameColumn,
  getCounterSignedPurchaseOfferDateColumn,
  getCurrentStepColumn,
  getFurnitureAndWorkPriceColumn,
  getRealMasteosCommissionPriceColumn,
  getRealNetSellerPriceColumn,
  getStatusColumn,
  getAddressLinkColumn,
  getTransactionIdColumn,
} from 'features/transactions/list/getTransactionColumns';
import { Translate } from 'react-admin';
import { GridColDef } from 'types/mui.types';
import { TransactionListItemFormatted } from 'types/transaction.types';

export const getCustomerTransactionColumns = (
  translate: Translate
): GridColDef<TransactionListItemFormatted>[] => {
  return [
    getStatusColumn(translate),
    getCurrentStepColumn(translate),
    getAddressLinkColumn(),
    getCounterSignedPurchaseOfferDateColumn(),
    getRealNetSellerPriceColumn(),
    getRealMasteosCommissionPriceColumn(),
    getFurnitureAndWorkPriceColumn(),
    getAdvisorFullNameColumn(),
    getTransactionIdColumn(),
  ];
};
